import { supabaseClient } from "@/lib/supabase";
import { FORM_MEDIA_BUCKET } from "./formMediaBucket";

export { FORM_MEDIA_BUCKET };

export const FORM_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const FORM_VIDEO_MAX_BYTES = 100 * 1024 * 1024;

const SAFE_NAME = /[^a-zA-Z0-9._-]+/g;

export function sanitiseMediaFileName(name: string): string {
    const trimmed = name.trim().toLowerCase().replace(SAFE_NAME, "-").replace(/-+/g, "-");
    return trimmed || "media";
}

export function buildFormMediaPath(formId: string, blockId: string, fileName: string): string {
    return `${formId}/${blockId}-${sanitiseMediaFileName(fileName)}`;
}

export function validateFormMediaFile(file: File, blockType: "image" | "video"): string | null {
    if (blockType === "image") {
        if (!file.type.startsWith("image/")) return "Choose an image file.";
        if (file.size > FORM_IMAGE_MAX_BYTES) return "Images must be 10MB or smaller.";
        return null;
    }
    if (!file.type.startsWith("video/") && file.type !== "") return "Choose a video file.";
    if (file.size > FORM_VIDEO_MAX_BYTES) return "Videos must be 100MB or smaller.";
    return null;
}

export async function uploadFormMedia(args: {
    formId: string;
    blockId: string;
    file: File;
}): Promise<{ url: string; path: string }> {
    const path = buildFormMediaPath(args.formId, args.blockId, args.file.name);
    const { error } = await supabaseClient.storage.from(FORM_MEDIA_BUCKET).upload(path, args.file, {
        upsert: true,
        contentType: args.file.type || undefined,
    });
    if (error) throw error;
    const { data } = supabaseClient.storage.from(FORM_MEDIA_BUCKET).getPublicUrl(path);
    return { url: data.publicUrl, path };
}
